<template>
    <div>
        <header class="header-wrapper">
            <div class="header-box">
                <div class="container">
                    <div class="row">
                        <div class="col">
                            <header-nav></header-nav>
                        </div>
                    </div>
                </div>
            </div>
        </header><!-- End Header -->
        <main class="main-box">
            <div class="team-head">
                <div class="container">
                    <div class="content-header content-box">
                        <div class="row">
                            <div class="col-md-4 offset-md-4">
                                <div class="content-header team-headline">
                                    <h1 class="content-title content-title_line">{{$t('meta.about.h1')}}</h1>
                                    <template v-if="showCommonTeamText">
                                        <h4 class="team-headline-title">{{$t('public.about.team_title')}}</h4>
                                        <span class="team-headline-text">{{$t('public.about.team_description')}}</span>
                                    </template>
                                    <template v-else>
                                        <h4 class="team-headline-title" v-text="$t('public.about.teams['+ activePersonIndex +'].name')"></h4>
                                        <small class="team-headline-text" v-text="$t('public.about.teams['+ activePersonIndex +'].job')"></small>
                                        <div class="team-headline-text" v-text="$t('public.about.teams['+ activePersonIndex +'].description')"></div>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Team Tab Navigation-->
                    <div class="team-tabs-nav" id="teams">
                        <ul>
                            <li class="team-tabs-nav-tab-1"><a href="#"><img src="~img/team/team-color-1.png" :alt="$t('meta.about.h1')"  :title="$t('meta.about.h1')"></a></li>
                            <li class="team-tabs-nav-tab-2"><a href="#"><img src="~img/team/team-color-2.png" :alt="$t('meta.about.h1')"  :title="$t('meta.about.h1')"></a></li>
                            <li class="team-tabs-nav-tab-3"><a href="#"><img src="~img/team/team-color-3.png" :alt="$t('meta.about.h1')"  :title="$t('meta.about.h1')"></a></li>
                            <li class="team-tabs-nav-tab-4"><a href="#"><img src="~img/team/team-color-4.png" :alt="$t('meta.about.h1')"  :title="$t('meta.about.h1')"></a></li>
                            <li class="team-tabs-nav-tab-5"><a href="#" class="active"><img src="~img/team/team-color-5.png" :alt="$t('meta.about.h1')"  :title="$t('meta.about.h1')"></a></li>
                            <li class="team-tabs-nav-tab-6"><a href="#"><img src="~img/team/team-color-6.png" :alt="$t('meta.about.h1')"  :title="$t('meta.about.h1')"></a></li>
                            <li class="team-tabs-nav-tab-7"><a href="#"><img src="~img/team/team-color-7.png" :alt="$t('meta.about.h1')"  :title="$t('meta.about.h1')"></a></li>
                            <li class="team-tabs-nav-tab-8"><a href="#"><img src="~img/team/team-color-8.png" :alt="$t('meta.about.h1')"  :title="$t('meta.about.h1')"></a></li>
                            <li class="team-tabs-nav-tab-9"><a href="#"><img src="~img/team/team-color-9.png" :alt="$t('meta.about.h1')"  :title="$t('meta.about.h1')"></a></li>
                            <li class="team-tabs-nav-tab-10"><a href="#"><img src="~img/team/team-color-10.png" :alt="$t('meta.about.h1')"  :title="$t('meta.about.h1')"></a></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-8">
                        <!-- Team Tab Body-->
                        <div class="team-tabs-body">
                            <div class="team-steps-wrap">
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="team-step shadow-sm">
                                            <h3 class="team-step-title">{{$t('public.about.blocks[0].title')}}</h3>
                                            <span class="team-step-text">{{$t('public.about.blocks[0].text')}}</span>
                                        </div>
                                        <div class="team-step shadow-sm">
                                            <h3 class="team-step-title">{{$t('public.about.blocks[2].title')}}</h3>
                                            <span class="team-step-text">{{$t('public.about.blocks[2].text')}}</span>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="team-step shadow-sm">
                                            <h3 class="team-step-title">{{$t('public.about.blocks[1].title')}}</h3>
                                            <span class="team-step-text">{{$t('public.about.blocks[1].text')}}</span>
                                        </div>
                                        <div class="team-step shadow-sm">
                                            <h3 class="team-step-title">{{$t('public.about.blocks[3].title')}}</h3>
                                            <span class="team-step-text">{{$t('public.about.blocks[3].text')}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="team-info-wrap">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="team-info team-info_indent">
                                            <span class="team-info-text" v-html="$t('public.about.info1')"></span>
                                            <span class="team-info-text" v-html="$t('public.about.info2')"></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
        <footer-component></footer-component>
    </div>
</template>

<script>
    export default {
        name: 'test',
        data() {
            return {
                showCommonTeamText: true,
                activePersonIndex: null
            }
        },
        metaInfo() {
            return {
                title: this.$t('meta.about.title'),
                meta: [
                    { vmid: 'description', name: 'description', content: this.$t('meta.about.description') },
                ]
            }
        },
        mounted() {
            [].forEach.call(document.querySelectorAll('.team-tabs-nav a'), (link, index) => {
                link.addEventListener('click', (e) => {
                    e.preventDefault();
                    [].forEach.call(document.querySelectorAll('.team-tabs-nav a'), (link) => {
                        link.classList.remove('active', 'multicolor')
                    })
                    this.showCommonTeamText = false
                    link.classList.add('multicolor')
                    this.activePersonIndex = index
                })
            })

            let specifiedElement = document.getElementById('teams')
            document.addEventListener('click', (event) => {
                let isClickInside = specifiedElement.contains(event.target)
                if (!isClickInside) {
                    this.showCommonTeamText = true
                    this.activePersonIndex = null
                    let multiEl = document.querySelector('.team-tabs-nav a.multicolor')
                    if (multiEl) {
                        multiEl.classList.remove('multicolor')
                    }
                    document.querySelector('.team-tabs-nav-tab-5 a').classList.add('active')
                }
            })
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Public/About.vue